export const formatoOptions = [
  { value: '', label: 'Select' },
  { value: 'iabStd', label: 'IAB - Standard' },
  { value: 'iabRm', label: 'IAB - RichMedia' },
  { value: 'expandivel', label: 'Expandable' },
  { value: 'fullscreen', label: 'Fullscreen' },
  { value: 'dvast', label: 'DVAST' },
  { value: 'shoppable', label: 'Shoppable' },
];

export const stepsOptions = [
  { value: '', label: 'Select' },
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3 or more' },
];

export const mockupOptions = [
  { value: '', label: 'Select' },
  { value: 'clienteFornece', label: 'Client provides mockups (PSD)' },
  { value: 'desdobrar', label: 'Adapt existing mockups (PSD or PNG)' },
  { value: 'criar', label: 'Create mockups from scratch' },
];

export const alimentacaoOptions = [
  { value: '', label: 'Select' },
  { value: 'nenhuma', label: 'No update' },
  { value: 'manual', label: 'Manual spreadsheet (upload)' },
  { value: 'powerfeed', label: 'PowerFeed integration (automatic)' },
];

export const urgenciaOptions = [
  { value: '', label: 'Select' },
  { value: 'baixa', label: 'Low' },
  { value: 'media', label: 'Medium' },
  { value: 'alta', label: 'High' },
];

export const volumetriaOptions = [
  { value: '', label: 'Select' },
  { value: 'ate10mi', label: 'Up to 10 million' },
  { value: '10a50mi', label: '10 to 50 million' },
  { value: '50a100mi', label: '50 to 100 million' },
  { value: 'acima100mi', label: 'Over 100 million' },
];

export const tipoDcoOptions = [
  { label: 'Basic', value: 'basico' },
  { label: 'Weather', value: 'clima' },
  { label: 'Geolocation', value: 'geo' },
  { label: 'Date and Time', value: 'dataHora' },
  { label: 'Audience Segmentation', value: 'segmentacaoAudiencia' }
];

export const dimensoesOptions = [
  { value: '', label: 'Select' },
  { label: '300x250', value: '300x250' },
  { label: '728x90', value: '728x90' },
  { label: '160x600', value: '160x600' },
  { label: '300x600', value: '300x600' },
  { label: '970x250', value: '970x250' },
  { label: '320x50', value: '320x50' },
  { label: '320x100', value: '320x100' },
  { label: '336x280', value: '336x280' },
  { label: '468x60', value: '468x60' },
  { label: '120x600', value: '120x600' },
  { label: '1920x1080', value: '1920x1080' },
  { label: '1280x720', value: '1280x720' },
  { label: '640x360', value: '640x360' },
  { label: '480x320', value: '480x320' },
  { label: '1080x1080', value: '1080x1080' },
  { label: '1200x628', value: '1200x628' },
  { label: 'Others', value: 'outros' }
];

/* Peso é de 0 a 5 */
export const pesos = {
  formato: {
    iabStd: 1,
    iabRm: 1.5,
    expandivel: 1.7,
    fullscreen: 2,
    dvast: 2,
    shoppable: 2.2
  },
  dvastSkip: 0,
  carrossel: 2.2,
  steps: {
    '1': 1,
    '2': 4,
    '3': 6
  },
  possuiItensDinamicos: {
    sim: 1,
    nao: 0
  },
  mockup: {
    clienteFornece: 1,
    desdobrar: 2.5,
    criar: 3
  },
  desdobramentos: { base: 2 },
  alimentacao: {
    nenhuma: 0,
    manual: 1,
    powerfeed: 1.5
  },
  urgencia: {
    baixa: 0,
    media: 1,
    alta: 2
  },
  tipoDCO: {
    basico: 1,
    clima: 2,
    geo: 2,
    dataHora: 2,
    segmentacaoAudiencia: 2,
    feeds: 2
  }
};

/* PDF Messages */
export const AVISOS = {
  avisoTag: '! Warning: Serving this format requires support for our TAG.',
  avisoVast3: '! Warning: This format requires compatibility with VAST 3.0 TAG.',
  avisoVast2: '! Warning: This format requires compatibility with VAST 2.0 TAG.'
};

export const LINKS = {
  mockupSpecs: 'https://suaempresa.com/specs-mockup',
  psdMockup: 'https://suaempresa.com/mockup-modelo.psd',
  entregaMockup: 'https://suaempresa.com/instrucoes-entrega',
  planilhaVersoes: 'https://suaempresa.com/modelo-planilha-versoes.xlsx'
};
